<div class="productPrices ml-5" *ngFor="let adjustment of adjustments; index as i">
  <div class="priceContent">
    <label class="priceContent__label">Override</label>
    <div class="input-group mb-3 priceContent__inputContainer">
      <select
        class="custom-select priceContent__input"
        [(ngModel)]="adjustment.AdjustmentType"
        (change)="adjustmentTypeChanged(adjustment, $event)"
        id="inputGroupSelect01"
      >
        <option>Choose...</option>
        <option *ngFor="let adjustmentType of adjustmentTypes" [value]="adjustmentType.id">{{ adjustmentType.name }}</option>
      </select>
    </div>
  </div>

  <div class="priceContent">
    <label class="priceContent__label">Price</label>
    <div class="input-group mb-3 priceContent__inputContainer">
      <div class="input-group-prepend pricContent__inputPrepend">
        <span class="input-group-text priceContent__inputPrependContent">
          {{ this.globals.countries[price.CountryId] ? this.globals.countries[price.CountryId].Code : "" }}
        </span>
      </div>
      <input [(ngModel)]="adjustment.Price" type="number" step="0.01" class="form-control priceContent__input" aria-label="Amount" />
    </div>
  </div>

  <div class="priceContent">
    <label class="priceContent__label">Discount</label>
    <div class="input-group mb-3 priceContent__inputContainer">
      <div class="input-group-prepend pricContent__inputPrepend">
        <span class="input-group-text priceContent__inputPrependContent">
          {{ this.globals.countries[price.CountryId] ? this.globals.countries[price.CountryId].Code : "" }}
        </span>
      </div>
      <input [(ngModel)]="adjustment.Discount" type="number" step="0.01" class="form-control priceContent__input" aria-label="Discount" />
    </div>
  </div>

  <div class="priceContent">
    <label class="priceContent__label">Points</label>
    <div class="input-group mb-3 priceContent__inputContainer">
      <div class="input-group-prepend pricContent__inputPrepend">
        <span class="input-group-text priceContent__inputPrependContent">{{ adjustment.pointType }}</span>
      </div>
      <input [(ngModel)]="adjustment.Points" type="number" step="0.01" class="form-control priceContent__input" aria-label="Points" />
    </div>
  </div>

  <div class="prodcutPrices__buttonContainer">
    <button type="button" class="btn btn-primary productPrices__saveButton mr-2" (click)="savePriceAdjustment(adjustment)">
      <span>Save</span>
    </button>
    <button type="button" *ngIf="adjustment.Id" class="btn btn-danger productPrices__saveButton" (click)="deleteAdjustment(adjustment)">
      <span>Delete</span>
    </button>
    <button *ngIf="i == adjustments.length - 1" mat-icon-button aria-label="Add an adjustment" (click)="addAdjustment()">
      <mat-icon>add_circle_outline</mat-icon>
    </button>
  </div>
</div>
